import braintreeClient from 'braintree-web/client';
import { Action } from 'app/store/actions';
import {
  uninitializedRemoteData,
  unfetchedRemoteData,
  fetchedRemoteData,
  remoteDataError,
  RemoteData,
} from 'app/store/remoteData';
export type BraintreeClient = RemoteData<braintreeClient.Client>;
const defaultState = uninitializedRemoteData<braintreeClient.Client>();
export default function braintreeClientReducer(
  state: BraintreeClient = defaultState,
  action: Action,
): BraintreeClient {
  switch (action.type) {
    case 'INITIALIZE_BRAINTREE_START':
      return unfetchedRemoteData<braintreeClient.Client>();
    case 'INITIALIZE_BRAINTREE_SUCCESS':
      return fetchedRemoteData<braintreeClient.Client>(action.braintreeClient);
    case 'INITIALIZE_BRAINTREE_FAIL':
      return remoteDataError<braintreeClient.Client>(action.message);
    default:
      return state;
  }
}
